import { isEditOrPreviewMode } from '@/lib/editModeHelpers';
import classnames from 'classnames';
import React from 'react';
import VisibilityObserver from '../ui/VisibilityObserver';
import withPliErrorBoundary from '../blocks/ErrorBoundary/withPliErrorBoundary';

interface BlockProps<El extends HTMLElement> extends React.HTMLProps<El> {
  element?: 'section' | 'div' | React.ElementType;
  contentLinkID?: number;
  onVisible?: () => void;
  useErrorBoundary?: boolean;
  propertyName?: string;
}

function Block<El extends HTMLElement = HTMLDivElement>({
  element,
  contentLinkID,
  onVisible,
  children,
  className,
  useErrorBoundary = false,
  ...props
}: BlockProps<El>) {
  const isEditMode = isEditOrPreviewMode();
  const Element = element || 'section';

  const conditionalProps =
    isEditMode && contentLinkID ? { ...props, 'data-epi-block-id': contentLinkID } : props;

  if (!isEditMode && !children) return null;

  const componentCode = (
    <Element {...conditionalProps} className={classnames(className, 'relative')}>
      <VisibilityObserver onVisible={onVisible}>{children}</VisibilityObserver>
    </Element>
  );

  if (useErrorBoundary) {
    const ComponentForBoundary = () => componentCode;
    const Wrapped = withPliErrorBoundary(ComponentForBoundary, { name: 'BlockComponentBoundary' });
    return <Wrapped />;
  }

  return componentCode;
}

export default Block;
